"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findVariableDeclaration = findVariableDeclaration;
const VariableStore_1 = require("./VariableStore");
const characterInstanceNames_1 = require("../utils/characterInstanceNames");
function resolveDefaultFromDeclaration(decl) {
    return VariableStore_1.VariableStore.resolveDefaultValue(decl.type, decl.defaultValue);
}
/**
 * Finds a resettable variable declaration on the merged adventure definition.
 * v1 supports adventure-level and character-level declarations only.
 */
function findVariableDeclaration(adventure, variableName, options) {
    const name = (variableName ?? '').trim();
    if (!name) {
        return undefined;
    }
    const characterName = (options?.characterName ?? '').trim();
    if (characterName) {
        const templateName = (0, characterInstanceNames_1.getCharacterTemplateName)(characterName);
        const character = adventure.characters?.find((c) => c.name === templateName);
        const charDecl = character?.variables?.find((v) => v.name === name);
        if (charDecl) {
            return {
                scope: 'character',
                type: charDecl.type,
                defaultValue: resolveDefaultFromDeclaration(charDecl),
                characterName
            };
        }
    }
    const sharedCharDecl = adventure.characterVariables?.find((v) => v.name === name);
    if (sharedCharDecl) {
        if (!characterName) {
            return undefined;
        }
        return {
            scope: 'character',
            type: sharedCharDecl.type,
            defaultValue: resolveDefaultFromDeclaration(sharedCharDecl),
            characterName
        };
    }
    const adventureDecl = adventure.variables?.find((v) => v.name === name);
    if (adventureDecl) {
        return {
            scope: 'adventure',
            type: adventureDecl.type,
            defaultValue: resolveDefaultFromDeclaration(adventureDecl)
        };
    }
    return undefined;
}
//# sourceMappingURL=variableDeclarationLookup.js.map